import { HomePageSidebarNotificationLoadingState } from './HomePageSidebarNotificationLoadingState';
import { HomepageNotificationsEmptyState } from './HomePageSidebarNotificationsEmptyState';

type HomePageSidebarNotificationPlaceholdersProps = {
  isLoading: boolean;
  isEmpty: boolean;
};

export const HomePageSidebarNotificationPlaceholders: React.FC<HomePageSidebarNotificationPlaceholdersProps> = ({ isEmpty, isLoading }) => {
  if (isLoading) {
    return <HomePageSidebarNotificationLoadingState />;
  }

  if (isEmpty) {
    return <HomepageNotificationsEmptyState />;
  }

  return null;
};